// Date 2020-08-03 08:33:13

import emLcAccInstAccRepIar from "@/store/em/lifecycle/EmLcAccInstAccRepIarStore.js";
import emLcAccInstAccTypeIat from "@/store/em/lifecycle/EmLcAccInstAccTypeIatStore.js";
import emLcAdjustedReportAdr from "@/store/em/lifecycle/EmLcAdjustedReportAdrStore.js";
import emLcInstalledReportInr from "@/store/em/lifecycle/EmLcInstalledReportInrStore.js";
import emLcScrReasonSrea from "@/store/em/lifecycle/EmLcScrReasonSreaStore.js";
import emLcScrRecordSre from "@/store/em/lifecycle/EmLcScrRecordSreStore.js";
import emLcSdSelectionDemSde from "@/store/em/lifecycle/EmLcSdSelectionDemSdeStore.js";

const genericEntities = [
    'emLcAccInstAccRepIar',
    'emLcAccInstAccTypeIat',
    'emLcAdjustedReportAdr',
    'emLcInstalledReportInr',
    'emLcScrReasonSrea',
    'emLcScrRecordSre',
    'emLcSdSelectionDemSde'
]

const entities = {
    emLcAccInstAccRepIar,
    emLcAccInstAccTypeIat,
    emLcAdjustedReportAdr,
    emLcInstalledReportInr,
    emLcScrReasonSrea,
    emLcScrRecordSre,
    emLcSdSelectionDemSde
}

export {genericEntities}

export default entities